module.exports = __webpack_public_path__ + "static/img/menu_product.0baf680f.png";